import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SubmitButtonComponent } from "./components/submit-button/submit-button.component";
import { InputContainerComponent } from "./components/input-container/input-container.component";
import { TableActionsComponent } from "./components/table-actions/table-actions.component";
import { InlineSVGModule } from "ng-inline-svg";
import { FileUploaderComponent } from "./components/file-uploader/file-uploader.component";
import { MaterialModule } from "../material/material.module";
import { UploadedImageComponent } from "./components/uploaded-image/uploaded-image.component";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { ModalProgressComponent } from "./components/modal-progress/modal-progress.component";
import { DeleteModalComponent } from "./components/delete-modal/delete-modal.component";
import { NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { EditModalComponent } from "./components/edit-modal/edit-modal.component";
import { StarRatingComponent } from "./components/star-rating/star-rating.component";
import { GenerateLinkComponent } from "./components/generate-link/generate-link.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { QrcodeComponent } from "./components/qrcode/qrcode.component";
import { QrCodeModule } from "ng-qrcode";

@NgModule({
  declarations: [
    SubmitButtonComponent,
    InputContainerComponent,
    TableActionsComponent,
    FileUploaderComponent,
    UploadedImageComponent,
    SpinnerComponent,
    ModalProgressComponent,
    DeleteModalComponent,
    EditModalComponent,
    StarRatingComponent,
    GenerateLinkComponent,
    QrcodeComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InlineSVGModule,
    MaterialModule,
    MatButtonToggleModule,
    NgSelectModule,
    NgbModalModule,
    QrCodeModule,
  ],
  exports: [
    SubmitButtonComponent,
    InputContainerComponent,
    TableActionsComponent,
    QrCodeModule,
    FileUploaderComponent,
    UploadedImageComponent,
    SpinnerComponent,
    MaterialModule,
    EditModalComponent,
    DeleteModalComponent,
    StarRatingComponent,
  ],
})
export class SharedModule {}
